module.exports = __webpack_public_path__ + "static/media/call_state@2x.dfcb61f8.png";